import './SubSectionList.css';
import React from 'react';

function SubSectionList(props) {
  // Получаем текущий URL страницы без домена и параметров
  const currentPath = window.location.pathname;

  return (
      <section id={'sub-section-tags'}>
        <ul className="section-tags">
          {
            props.sections.map(section => {
              // Проверяем, соответствует ли текущий путь пути раздела
              if (section.url !== currentPath) {
                return (
                    <li key={section.url}>
                      <a href={section.url}>
                        <img
                            src={section.image.src}
                            width={section.image.width}
                            height={section.image.height}
                        />
                        <span>{section.title}</span>
                      </a>
                    </li>
                );
              } else {
                return null; // Не выводим элемент, если пути совпадают
              }
            })
          }
        </ul>
      </section>
  );
}

export default SubSectionList;